import React from 'react';
import styles from './index.module.less';
import {Classes, Colors, Icon} from "@blueprintjs/core";
import classes from 'classnames';

const JudgeCases = ({ cases }) => {
  return (
    <div className={styles['judge-cases']}>
      <h3 className={Classes.HEADING}>测试用例</h3>
      <table className={classes(Classes.HTML_TABLE, Classes.HTML_TABLE_BORDERED)}>
        <thead>
        <tr>
          <th>调用函数</th>
          <th>期望结果</th>
          <th>执行结果</th>
          <th>Accepted</th>
        </tr>
        </thead>
        <tbody>
        {cases.map((judgeCase, index) => (
          <tr key={index}>
            <td>{judgeCase.test_case}</td>
            <td>{String(judgeCase.expect)}</td>
            <td>{String(judgeCase.run)}</td>
            <td>
              {judgeCase.status === 'OK' ? <Icon icon='tick' color={Colors.GREEN5} /> : <Icon icon='cross' color={Colors.RED5} />}
            </td>
          </tr>
        ))}

        </tbody>
      </table>
    </div>
  );
};

export default JudgeCases;
